import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './OpusAddressEditForm.html?raw';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { MainCatalogTypes } from "../../../_loadingHelpers/MainCatalogTypes";
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import SearchSelect from '../../../../moreCore/UI/SearchSelect/SearchSelect';


class OpusAddressEditForm extends compose(_WidgetBaseSP) {
    templateString: string = template;


    private address_input: MdsLax<InstanceType<typeof HintBox>>;
    private relation_type_input: MdsLax<InstanceType<typeof SearchSelect>>;

    private data: MainCatalogTypes.RelatedAddressTableEntry;
    private isDirty: boolean = false;


    private _getIsDirty(): boolean {
        return this.isDirty;
    }

    private _setData(data: MainCatalogTypes.RelatedAddressTableEntry): void {
        this.data = data;
    }

    getData(): MainCatalogTypes.RelatedAddressTableEntry {
        this.data.ref_address = this.address_input.getValue("entity");
        this.data.ref_relation_type = this.relation_type_input.getValue(true);
        return this.data;
    }

    setupForm(entry: MainCatalogTypes.RelatedAddressTableEntry): void {
        this._setData(entry);
        this.address_input.setValue(entry.ref_address, true);
        this.relation_type_input.loadListValues(entry.ref_relation_type.ID, true);
    }

    private _onChange(): void {
        this._setIsDirty(true);
    }

    private _setIsDirty(isDirty: boolean): void {
        this.isDirty = isDirty;
    }

    getIsDirty(): boolean {
        return this.isDirty;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.relation_type_input.loadListValues()
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
    
}

mdsLazyProto(OpusAddressEditForm.prototype, {
  address_input: () => (new HintBox()),
  relation_type_input: () => (new SearchSelect()),
});
export default mdsWidget(OpusAddressEditForm);